module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA1BMVEUAev9fqEMrAAAAC0lEQVQI12MgEQAAADAAAWV61nwAAAAASUVORK5CYII="